import { render, staticRenderFns } from "./BridgeModal.vue?vue&type=template&id=47ad639c&scoped=true"
import script from "./BridgeModal.vue?vue&type=script&lang=ts"
export * from "./BridgeModal.vue?vue&type=script&lang=ts"
import style0 from "./BridgeModal.vue?vue&type=style&index=0&id=47ad639c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ad639c",
  null
  
)

export default component.exports